import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';

export type LogoutAction = ActionMessage<'logout'>;

export const logout = invokeAction('uniclientAction', 'logout');
